import React from "react";
import Layout from "../../components/layout/Layout";
import EmployeeLeaveTable from "./components/EmployeeLeaveTable";

const LeaveManagement = () => {
  return (
    <Layout>
      <div className="container-fluid py-4 px-lg-4">
        <EmployeeLeaveTable />
      </div>
    </Layout>
  );
};

export default LeaveManagement;
